function updateURLAndSubmit(): void {
	const selectedCategories: string[] = [];
	const categoryCheckboxes = document.querySelectorAll("input[name='categories[]']:checked");

	categoryCheckboxes.forEach((checkbox) => {
		selectedCategories.push((checkbox as HTMLInputElement).value);
	});

	const url = new URL(window.location.href);

	// Remove the pagination from the URL
	url.pathname = url.pathname.replace(/\/page\/\d+/, '');
	url.search = url.search.replace(/[?&]page=[^&]*(&|$)/, "$1").replace(/[?&]$/, "");

	if (selectedCategories.length > 0) {
		url.searchParams.set("categories", selectedCategories.join(","));
	} else {
		url.searchParams.delete("categories");
	}

	// Check if all categories are checked, remove query from URL if so
	const allCategoriesChecked =
		document.querySelectorAll("input[name='categories[]']").length ===
		categoryCheckboxes.length;
	if (allCategoriesChecked) {
		url.searchParams.delete("categories");
	}

	// Decode URL
	window.location.href = decodeURIComponent(url.toString());
}

function isMobileViewActive(): boolean {
	return window.matchMedia("(max-width: 680px)").matches;
}

document.addEventListener('DOMContentLoaded', function () {
	const newsFilter = document.getElementById("news-filter");
	if (newsFilter) {
		const urlParams = new URLSearchParams(window.location.search);
		const categories = urlParams.get("categories");
		const filterSubSection = newsFilter.querySelector(".filter-sub-section");

		// Check categories checkboxes based on URL query
		if (categories) {
			const categoryValues = categories.split(",");
			if (filterSubSection) {
				filterSubSection.classList.add("active");
			}
			categoryValues.forEach((value) => {
				const checkbox = document.querySelector(`input[name='categories[]'][value='${value}']`) as HTMLInputElement;
				if (checkbox) {
					checkbox.checked = true;
				}
			});
		} else {
			if (filterSubSection) {
				filterSubSection.classList.remove("active");
			}
		}

		// Listen for changes in the checkboxes on desktop
		const categoryCheckboxes = document.querySelectorAll("input[name='categories[]']");
		let focusedCheckboxIndex = -1;
		categoryCheckboxes.forEach((checkbox, index) => {
			// Keyboard controlls
			checkbox.addEventListener("keydown", (event) => {
				const keyboardEvent = event as KeyboardEvent;
				// Up & down arrows
				if (keyboardEvent.key === "ArrowUp" || keyboardEvent.key === "ArrowDown") {
					event.preventDefault();
					const categoryCheckboxesLength = categoryCheckboxes.length;
					const step = keyboardEvent.key === "ArrowUp" ? -1 : 1;
					const nextCheckboxIndex = (focusedCheckboxIndex + step + categoryCheckboxesLength) % categoryCheckboxesLength;

					if (focusedCheckboxIndex !== nextCheckboxIndex) {
						focusedCheckboxIndex = nextCheckboxIndex;
						const nextCheckbox = categoryCheckboxes[focusedCheckboxIndex] as HTMLInputElement;
						nextCheckbox.focus();
					}
				}

				if (keyboardEvent.key === "Enter") {
					keyboardEvent.preventDefault();
					if (checkbox instanceof HTMLInputElement) {
						checkbox.checked = !checkbox.checked;
						checkbox.dispatchEvent(new Event("change"));
						updateURLAndSubmit();
					}
				}
			});
			checkbox.addEventListener("focus", () => {
				focusedCheckboxIndex = index;
			});
			checkbox.addEventListener("change", () => {
				if (!isMobileViewActive()) {
					updateURLAndSubmit();
				} else {
					const inputCheckbox = checkbox as HTMLInputElement;
					if (!inputCheckbox.checked || inputCheckbox.classList.contains("checked")) {
						inputCheckbox.classList.toggle("checked");
					}
				}
			});
		});

		// Toggle for mobile view
		const newsToggle = document.getElementById("news-toggle");
		if (newsToggle) {
			newsToggle.addEventListener("click", (event) => {
				event.preventDefault();
				newsFilter.classList.toggle("active");
				newsToggle.setAttribute("aria-expanded", "true");
			});
		}

		// Add event listeners to buttons with specific classes
		const filterSubmit = document.querySelector(".filter-submit");
		if (filterSubmit) {
			filterSubmit.addEventListener("click", (event) => {
				event.preventDefault();
				updateURLAndSubmit();
			});
		}

		const filterClear = document.querySelector(".filter-clear");
		if (filterClear) {
			filterClear.addEventListener("click", (event) => {
				event.preventDefault();
				categoryCheckboxes.forEach((checkbox) => {
					const inputCheckbox = checkbox as HTMLInputElement;
					inputCheckbox.checked = true;
				});
				updateURLAndSubmit();
			});
		}
	}
});